import { ClaimRewardsDialogContentContainer } from './ClaimRewardsDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

function ClaimRewardsDialog({ open, setOpen }: CommonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <ClaimRewardsDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const claimRewardsDialogConfig: DialogConfig<CommonDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: ClaimRewardsDialog,
  name: 'ClaimRewardsDialog',
}
